import fly from '../fly'

export const getPageInfo = (param) =>{
  return fly.post("/warn/page",param)
}

